import * as React from "react";
import { Route, Routes } from "react-router-dom";

import { AppBaseLayout, AppGuard } from "../components";
import B2CLogin from "../pages/B2C-Login/B2c-login";
// import { NavBar } from "../components";
import LoginComplete from "../pages/B2C-Login/LoginComplete";
import { PayLinkBaseLayout } from "../pages/PayLink/components";
import { PayLinkCheckout } from "../pages/PayLink/pages/checkout";
import { PayLinkLogin } from "../pages/PayLink/pages/login/PayLinkLogin";
import { PayLinkLoginComplete } from "../pages/PayLink/pages/login/PayLinkLoginComplete";
import { OrderConfirmed } from "../pages/PayLink/pages/order-confirmed/OrderConfrmed";
import { PayLinkStore } from "../pages/PayLink/pages/store/Store";
import { PaymentMethod } from "../pages/PaymentMethod";
import { PaymentSuccess } from "../pages/PaymentSuccess";
import { VerifyPayment } from "../pages/VerifyPayment";
import WalletCheckout from "../pages/WalletCheckout/WalletCheckout";
import BookADemo from "../pages/Website/book-a-demo/BookADemo";
import { DeveloperTools } from "../pages/Website/DeveloperTools/DeveloperTools";
import { LandingPage } from "../pages/Website/Home/Home";
import { Pricing } from "../pages/Website/Pricing/Pricing";

const MainROutes = () => {
  return (
    <React.Fragment>
      <Routes>
        {/* Website URL */}
        <Route path="/home" element={<LandingPage />} />
        <Route path="pricing" element={<Pricing />} />
        <Route path="book-a-demo" element={<BookADemo />} />
        <Route path="developer-tools" element={<DeveloperTools />} />
        <Route path="*" element={"Page Not Found... "} />

        <Route path="/logout" element={<LoginComplete />} />
        <Route path="/login" element={<B2CLogin />} />

        {/* Protected routes */}
        <Route path="/" element={<AppGuard />}>
          <Route element={<AppBaseLayout />}>
            <Route path="/" element={<WalletCheckout />} />
            <Route path="payment-method" element={<PaymentMethod />} />
            <Route path="verify-payment" element={<VerifyPayment />} />
            <Route path="payment-success" element={<PaymentSuccess />} />
            <Route path="/loginComplete" element={<LoginComplete />} />
          </Route>
        </Route>

        {/* Paylink Protected routes  */}
        <Route path="/paylink" element={<PayLinkBaseLayout />}>
          {/* <Route index element={<PayLinkCheckout />} /> */}
          <Route path="login" element={<PayLinkLogin />} />
          <Route path="loginComplete" element={<PayLinkLoginComplete />} />
          <Route path="s/:storeSlug" element={<PayLinkStore />} />
          <Route path="s/:storeSlug/p/:variantUrn" element={<PayLinkStore />} />
          <Route path="session" element={<PayLinkCheckout />} />
          <Route path="order-confirmed" element={<OrderConfirmed />} />
        </Route>
      </Routes>
    </React.Fragment>
  );
};

export default MainROutes;
